module.exports = __webpack_public_path__ + "img/warehouse-management.b2360593.png";